//@ts-check
import router from '../router';

class CoreError {

  constructor(payload) {
    let properties = [];
    let obj = payload;
    do {
      properties= properties.concat(Object.getOwnPropertyNames(obj));
    } while (obj = Object.getPrototypeOf(obj));

    properties = properties.filter(p => p != "__proto__");
    for (let property of properties) {
      this[property] = payload[property];
    }
  }

}

class Core {

  constructor() {
    this._loginToken = null;
    this._serverUrl = Parameters.urlServer; /* used as default, for login and for reset password */
    this._contextServerUrl = null;
    this._contextUrlApiException = [
      '/api/login'
    ]
    this.Error = CoreError;
  }

  getLoginToken() {
    return this._loginToken;
  }

  setLoginToken(token) {
    this._loginToken = token;
  }

  setContextServer(server) {
    this._contextServerUrl = server ? server.url : null;
  }

  getServerUrl() {
    return this._contextServerUrl || this._serverUrl;
  }

  getDatatableUrl() {
    return this.getServerUrl() + '/api/datatable/';
  }

  async noThrowRequest(method, url, data, options = {}) {
    try {
      return await this.request(method, url, data, options);
    } catch (e) {
      this.showRequestExceptionAsToast(e, method, url)
      return null;
    }
  }

  showRequestExceptionAsToast(e, method = '', url = '') {
    let asJson = window.tryParseAsJson(e.response);
    if (asJson && asJson.message && asJson.message.en) {
      toast(window.translateObject(asJson.message), 'error');
    } else if (asJson && asJson.key) {
      toast(asJson.key, 'error');
    } else {
      toast(`${e.statusText} ${method} ${url}`, 'error');
    }
  }

  /**
   * @param {string} method
   * @param {string} url
   * @param {any} data
   * @param options
   */
  request(method, url, data, options = {}) {
    return new Promise((resolve, reject) => {
      let request = new XMLHttpRequest();
      if (data && method === "GET") {
        let first = true;
        for (let key of Object.keys(data)) {
          if (data[key] === undefined) {
            continue;
          }
          if (data[key] && data[key].constructor === Array) {
            for (let array_item of data[key]) {
              url += (first ? "?" : "&") + key + "[]=" + array_item;
              if (first) {
                first = false;
              }
            }
          } else {
            url += (first ? "?" : "&") + key + "=" + data[key];
            if (first) {
              first = false;
            }
          }

        }
        data = null;
      }
      let baseUrl = this._contextServerUrl && !this._contextUrlApiException.find(ex => ex.includes(url))
        ? this._contextServerUrl
        : this._serverUrl;

      /* Override baseUrl */
      if (options.baseUrl) {
        baseUrl = options.baseUrl;
      }
      /* Ignore baseUrl, because url is a 'full' url */
      if (options.skipBaseUrl) {
        baseUrl = '';
      }

      request.open(method, baseUrl + url, true);
      request.onload = () => {
        if (request.status >= 200 && request.status < 400) {
          if (options.htmlResponse) {
            resolve(request.responseText);
          } else {
            let returnData;
            try {
              returnData = request.responseText ? JSON.parse(request.responseText) : request.status;
            } catch (e) {
              returnData = request.responseText;
            }
            resolve(returnData);
          }
        } else if (request.status === 401) {
          if (request.responseText && request.responseText.toUpperCase().indexOf("JWT") !== -1) {
            router.redirectToLogin();
          }
          reject(request);
        } else {
          reject(request);
        }
      };
      request.onerror = () => {
        reject(request);
      };
      if (!options.ignoreToken && this._loginToken) {
        request.setRequestHeader("Authorization", "Bearer " + this._loginToken);
      }
      if (data) {
        request.setRequestHeader("Content-type", "application/json");
      }
      if (options.headers) {
        for (let [key,value] of Object.entries(options.headers)) {
          request.setRequestHeader(key, value);
        }
      }

      request.send(data ? JSON.stringify(data) : undefined);
    });
  }

}

let core = new Core();

export { core as Core, Core as CoreClass };
